import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { LoginComponent } from './login.component';

/**
 * Declares the branded login page (SYRC-6097).
 *
 * Eager rather than lazy on purpose: /login is the entry point for every
 * unauthenticated visitor, so an extra chunk fetch would land on the one
 * navigation where first paint matters most.
 */
@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [LoginComponent],
})
export class LoginModule {}
